const DATE_FORMATS = {
	'pt-br': 'DD/MM/YYYY',
	'en-us': 'MM/DD/YYYY',
	'es-es': 'DD/MM/YYYY',
	'de-de': 'DD.MM.YYYY',
	'zh-cn': 'YYYY-MM-DD'
} as const;

export const dateFormat = () => {
	const locale = navigator.language.toLowerCase();

	if (!locale) {
		return 'MM/DD/YYYY';
	}

	if (locale === 'en-us') {
		return 'MM/DD/YYYY';
	}

	return DATE_FORMATS[locale as keyof typeof DATE_FORMATS] || 'MM/DD/YYYY';
};

export const dateTimeFormat = () => {
	const locale = navigator.language.toLowerCase();

	if (!locale) {
		return 'MM/DD/YYYY hh:mm A';
	}

	const timeFormats = {
		'pt-br': 'DD/MM/YYYY HH:mm',
		'en-us': 'MM/DD/YYYY hh:mm A',
		'es-es': 'DD/MM/YYYY HH:mm',
		'de-de': 'DD.MM.YYYY HH:mm',
		'zh-cn': 'YYYY-MM-DD HH:mm'
	};

	if (locale === 'en-us') {
		return 'MM/DD/YYYY hh:mm A';
	}

	return timeFormats[locale as keyof typeof timeFormats] || 'MM/DD/YYYY hh:mm A';
};
